import React from 'react';
import {Container, Col} from 'react-bootstrap';
import {HomeSectionTitle, HomeSectionType} from "../../../utils/common-styles";
import {LoadingStyledEventRow, LoadingStyledEventPost, LoadingStyledEventThumb, LoadingStyledEventText} from "../../../utils/loading-styles";

export const LoadingHomeEventsList = () => {

    return (
        <>
            <HomeSectionTitle><strong>Our Next   ____</strong></HomeSectionTitle>
            <HomeSectionType><h2>Events</h2></HomeSectionType>
            <Container>
            {[...Array(2)].map((_, index) => (
            <div key={index}>
                <LoadingStyledEventRow>
                        <LoadingStyledEventPost>
                            <LoadingStyledEventThumb xs={12}>
                                &nbsp;
                            </LoadingStyledEventThumb>
                            <Col xs={12}>
                            <LoadingStyledEventText>
                                <h6>&nbsp;</h6>
                                <p>&nbsp;</p>
                            </LoadingStyledEventText>
                            </Col>
                        </LoadingStyledEventPost>
                        </LoadingStyledEventRow>
            </div>
        ))}
            </Container>
        </>
    );
};
